module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.localReg) ? _c('el-container', {
    staticClass: "bg-gradient"
  }, [_c('vue-particles', {
    attrs: {
      "color": "#66B1FF",
      "particleOpacity": 0.7,
      "particlesNumber": 108,
      "particleSize": 5,
      "linesColor": "#909399",
      "lineOpacity": 0.528
    }
  }), _vm._v(" "), (_vm.isDesktop) ? _c('el-aside', {
    staticStyle: {
      "background-color": "#545c6480"
    }
  }, [_c('el-menu', {
    attrs: {
      "background-color": "#2f3e5785",
      "text-color": "#fff",
      "active-text-color": "#ffd04b",
      "default-active": "1-1"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" "), _c('span', [_vm._v("Features")])]), _vm._v(" "), _c('el-menu-item-group', {
    attrs: {
      "title": "Any Organisation:"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "0-1"
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" Tower Companies, "), _c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Telcos")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "0-2"
    }
  }, [_c('i', {
    staticClass: "fa fa-wifi"
  }), _vm._v(" Backhaul Providers")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "0-3"
    }
  }, [_c('i', {
    staticClass: "fa fa-tools"
  }), _vm._v(" Contractors, "), _c('i', {
    staticClass: "fa fa-store-alt"
  }), _vm._v(" Landlords")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "0-4"
    }
  }, [_c('i', {
    staticClass: "fa fa-broadcast-tower"
  }), _vm._v(" Tower Suppliers")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "0-5"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  }), _vm._v(" Authorities, "), _c('i', {
    staticClass: "fa fa-plug"
  }), _vm._v(" Utilities")])], 1), _vm._v(" "), _c('el-menu-item-group', {
    attrs: {
      "title": "Projects:"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt"
  }), _vm._v(" Request to Share")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2"
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v(" Request to Upgrade")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-3"
    }
  }, [_c('i', {
    staticClass: "fa fa-wifi"
  }), _vm._v(" Request to Backhaul")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-4"
    }
  }, [_c('i', {
    staticClass: "fa fa-broadcast-tower"
  }), _vm._v(" View All Your Sites")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-5"
    }
  }, [_c('i', {
    staticClass: "fa fa-tools"
  }), _vm._v(" Installed Equipment")])], 1), _vm._v(" "), _c('el-menu-item-group', {
    attrs: {
      "title": "Service:"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "2-4"
    }
  }, [_c('i', {
    staticClass: "fa fa-headset"
  }), _vm._v(" Instant Tickets")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2-5"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Custom Workflows")])], 1)], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_c('i', {
    staticClass: "fa fa-th-large"
  }), _vm._v(" "), _c('span', [_vm._v("Easy, Mobile Friendly")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-cog"
  }), _vm._v(" "), _c('span', [_vm._v("Consistent, Accurate Data")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-main', [_c('div', [_c('el-row', [(_vm.isDesktop) ? _c('el-col', {
    attrs: {
      "xs": 0,
      "sm": 24,
      "md": 24,
      "lg": 8
    }
  }, _vm._l((_vm.telcoLogos), function(l, i) {
    return _c('el-col', {
      key: i,
      attrs: {
        "align": "center",
        "xs": _vm.media.xs,
        "sm": _vm.media.sm,
        "md": _vm.media.md,
        "lg": _vm.media.lg
      }
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": l.src,
        "alt": l.alt
      }
    })])
  }), 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "inner-box",
    staticStyle: {
      "padding-bottom": "2.85rem"
    },
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 8,
      "align": "center"
    }
  }, [_c('center', [(_vm.clientLogo) ? _c('img', {
    staticStyle: {
      "height": "2.85rem",
      "padding": "0.8em"
    },
    attrs: {
      "src": _vm.clientLogo,
      "alt": _vm.clientName
    }
  }) : _vm._e()]), _vm._v(" "), (!_vm.isMaint && !_vm.isUnpaid) ? _c('div', [(_vm.logoutReason === 'session-expired') ? _c('div', {
    staticClass: "session-expired-msg",
    attrs: {
      "role": "status"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Your session has expired. Please sign in again.\n            ")]) : _vm._e(), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "padding": "2.85rem"
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "max-width": "400px",
      "margin": "0 auto"
    },
    attrs: {
      "placeholder": "Login",
      "type": "text"
    },
    model: {
      value: (_vm.login),
      callback: function($$v) {
        _vm.login = $$v
      },
      expression: "login"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('password', {
    attrs: {
      "toggle": ""
    },
    model: {
      value: (_vm.pwd),
      callback: function($$v) {
        _vm.pwd = $$v
      },
      expression: "pwd"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "fa fa-right-to-bracket",
      "loading": _vm.loggingIn,
      "disabled": _vm.loggingIn || (!_vm.login) || (!_vm.pwd)
    },
    on: {
      "click": _vm.doLogin
    }
  }, [_vm._v(" " + _vm._s(_vm.loggingIn ? 'Signing in...' : 'Login'))])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "fa fa-user-plus",
      "disabled": _vm.loggingIn || !(!_vm.login && !_vm.pwd)
    },
    on: {
      "click": _vm.doRegister
    }
  }, [_vm._v(" Register")])], 1)], 1)], 1)], 1) : _c('div', {
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [(_vm.isMaint) ? _c('center', [_c('h2', {
    staticClass: "text-warning"
  }, [_vm._v("Under Maintenance")])]) : _vm._e(), _vm._v(" "), (_vm.isUnpaid) ? _c('center', [_c('h2', {
    staticClass: "text-danger"
  }, [_vm._v("Overdue Payment")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "xolas-logo"
  }, [_c('a', {
    attrs: {
      "href": "https://xolas.io",
      "target": "_blank"
    }
  }, [_vm._v(" Powered by "), _c('img', {
    staticClass: "footer-logo",
    attrs: {
      "src": _vm.logo
    }
  }), _vm._v(" \n            " + _vm._s(_vm.appName))])])], 1), _vm._v(" "), (_vm.isDesktop) ? _c('el-col', {
    attrs: {
      "xs": 0,
      "sm": 24,
      "md": 24,
      "lg": 8
    }
  }, _vm._l((_vm.otherLogos), function(l, i) {
    return _c('el-col', {
      key: i,
      attrs: {
        "align": "center",
        "xs": _vm.media.xs,
        "sm": _vm.media.sm,
        "md": _vm.media.md,
        "lg": _vm.media.lg
      }
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": l.src,
        "alt": l.alt
      }
    })])
  }), 1) : _vm._e()], 1)], 1)])], 1) : _c('el-container', [_c('register', {
    attrs: {
      "new-system": _vm.xolasClient().contactsCount == 0 ? true : false
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e327b4ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Login.vue
// module id = 1725
// module chunks = 0